import React from 'react';
import ReactDOM from 'react-dom';
import NoToDos from './elements/NoToDos';
import ImportStatus from './elements/ImportStatus';
import ServerUpgrade from './elements/ServerUpgrade';
import ToDoNumber from './ToDoNumber';
import { t } from '../RI18n';
import './ToDoList.css';
import VmManagersStatus from './elements/VmManagersStatus';
import OutdatedActions from './elements/OutdatedActions';
import OutdatedDatabase from './elements/OutdatedDatabase';
import DatasourceConfiguration from './elements/DatasourceConfiguration';

class ToDoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: 0,
      importStatusLoaded: false,
      serverUpgradeLoaded: false,
      vmManagerStatusLoaded: false,
      outdatedActionsLoaded: false,
      outdatedDatabaseLoaded: false,
      datasourceConfigurationLoaded: false,
    };
    this.updateImport = this.updateImportStatus.bind(this);
    this.updateUpgrade = this.updateUpgradeStatus.bind(this);
    this.updateVmManager = this.updateVmManagerStatus.bind(this);
    this.updateActions = this.updateActionsStatus.bind(this);
    this.updateDatabase = this.updateDatabaseStatus.bind(this);
    this.updateDatasource = this.updateDatasourceStatus.bind(this);
  }

  componentDidUpdate() {
    const todoNumber = document.getElementById('todos-number');
    if (todoNumber !== null) {
      ReactDOM.render(<ToDoNumber items={this.state.items} />, todoNumber);
    }
  }

  updateImportStatus() {
    this.setState((prevState) => {
      const itemsCount = prevState.items + 1;
      return {
        items: itemsCount,
        importStatusLoaded: true,
      };
    });
  }

  updateUpgradeStatus() {
    this.setState((prevState) => {
      const itemsCount = prevState.items + 1;
      return {
        items: itemsCount,
        serverUpgradeLoaded: true,
      };
    });
  }

  updateVmManagerStatus() {
    this.setState((prevState) => {
      const itemsCount = prevState.items + 1;
      return {
        items: itemsCount,
        vmManagerStatusLoaded: true,
      };
    });
  }

  updateActionsStatus() {
    this.setState((prevState) => {
      const itemsCount = prevState.items + 1;
      return {
        items: itemsCount,
        outdatedActionsLoaded: true,
      };
    });
  }

  updateDatabaseStatus() {
    this.setState((prevState) => {
      const itemsCount = prevState.items + 1;
      return {
        items: itemsCount,
        outdatedDatabaseLoaded: true,
      };
    });
  }

  updateDatasourceStatus() {
    this.setState((prevState) => {
      const itemsCount = prevState.items + 1;
      return {
        items: itemsCount,
        datasourceConfigurationLoaded: true,
      };
    });
  }

  render() {
    return (
      <div
        className="todo-list"
        aria-label={t('todolist.items_count', { count: this.state.items })}
        role="region"
      >
        <br />
        <h3 className="todo-title">{t('todolist.title')}</h3>
        <hr />
        <div className="todo-content">
          <ImportStatus
            notify={!this.state.importStatusLoaded}
            updateToDos={this.updateImport}
          />
          <ServerUpgrade
            notify={!this.state.serverUpgradeLoaded}
            updateToDos={this.updateUpgrade}
          />
          <VmManagersStatus
            notify={!this.state.vmManagerStatusLoaded}
            updateToDos={this.updateVmManager}
          />
          <OutdatedActions
            notify={!this.state.outdatedActionsLoaded}
            updateToDos={this.updateActions}
          />
          <OutdatedDatabase
            notify={!this.state.outdatedDatabaseLoaded}
            updateToDos={this.updateDatabase}
          />
          <DatasourceConfiguration
            notify={!this.state.datasourceConfigurationLoaded}
            updateToDos={this.updateDatasource}
          />
        </div>
        <NoToDos items={this.state.items} />
      </div>
    );
  }
}

export default ToDoList;
